import { TabFallback } from '@/components/TabFallback';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from './types';

// Lazy-loaded: the page pulls in Recharts, which has no business in the
// initial bundle for the majority of users who will never open it.
const MetricsPage = lazy(() =>
  import('@/pages/metrics/MetricsPage').then((m) => ({ default: m.MetricsPage })),
);

/**
 * `/metrics` — leadership-facing marketplace metrics.
 *
 * `metrics:view` is the gate, held by `super_admin`, `marketplace_admin` and
 * the grantable `metrics_viewer` role. Deliberately NOT part of
 * `ADMIN_PERMISSIONS`: a metrics viewer must not acquire an Admin nav entry
 * or reach `/admin/*`.
 *
 * The `metrics-dashboard` public flag is checked INSIDE the page (rendering
 * `ComingSoon` when off) rather than on this handle, matching `/submissions`.
 * The route stays registered either way, so a direct URL lands on the page's
 * own gate instead of a 404.
 */
const handle: RouteHandle = {
  crumb: 'Metrics',
  requiredPermissions: ['metrics:view'],
};

export const metricsRoutes: RouteObject[] = [
  {
    path: 'metrics',
    element: (
      <Suspense fallback={<TabFallback />}>
        <MetricsPage />
      </Suspense>
    ),
    handle,
  },
];
